module.exports = __webpack_public_path__ + "assets/img/healthnet_preview.81e6736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/healthnet_preview.png
// module id = 46
// module chunks = 0